<template v-loading="loadsing">
  <el-row class="sec_box d2-mt-10 box-shadow" v-loading="loading">
    <div class="me-card" v-if="checked.mode != 'myDh'">
      <div class="info-row">
        <img :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/logo.png`" class="logo" />
        <img :src="
            userinfo.uInfo.avatarUrl && userinfo.uInfo.avatarUrl != ''
              ?userinfo.uInfo.avatarUrl.indexOf('http')!=-1?userinfo.uInfo.avatarUrl: $apiUrl + userinfo.uInfo.avatarUrl
              : require('@/assets/img/avatarUrl.png')
          " class="user" />
        <div class="info">
          <div class="yellow-text">{{ ampm }}，{{ userinfo.uInfo.Name }}</div>
          <div>
            <span class="yellow-radius">{{
              userinfo.uInfo.RoleName == "正式会员"
                ? "工会正式会员"
                : userinfo.uInfo.RoleName == "实习生"
                ? "工会实习生"
                : "工会预备会员"
            }}</span>
          </div>
        </div>
      </div>
      <div class="score-content">
        <div class="info-box">
          <div class="info-title">
            <d2-icon class="iconfont" :name="checked.mode == 'cash' ? 'ticket' : 'database'" />
            <span>{{
              checked.mode == "cash" ? "我的代金券" : "我的积分"
            }}</span>
          </div>
          <div class="info-content">
            <span
              class="value">{{ checked.mode == "cash"?BalanceMoney:Balance }}</span>{{ checked.mode == "cash" ? "元" : "分" }}
          </div>
        </div>
      </div>
      <div class="button-row" v-if="checked.mode == 'score'">
        <button @click="donationHandle">积分捐赠</button>
        <button @click="goExchangePlat">前往积分兑换平台</button>
        <button @click="summaryHandle">积分汇总</button>
        <button @click="transferHandle" :disabled="!cangiftVisible" :style="{'background':cangiftVisible?'':'#bcaaa2'}">积分转赠他人</button>
      </div>
      <div class="button-row" v-if="checked.mode == 'score'">
        
      </div>
    </div>
    <template v-if="checked.tabs">
      <el-tabs v-model="checked.active">
        <el-tab-pane v-for="(item, index) in checked.tab" :key="index" :label="item.name" :name="item.active">
          <p class="welfare_header" v-if="checked.mode == 'score' || checked.mode == 'cash'">
            {{ Year }}年
          </p>
          <p class="welfare_header" v-else>{{ Month }}</p>
          <p class="welfare_total" v-if="checked.mode == 'score'">
            统计日期：<el-date-picker v-model="selectDate" type="year" :clearable=false placeholder="选择年份"
              @change="handleYearSubmit" :picker-options="pickerOptions" :editable='false'>
            </el-date-picker>
            <el-button type="primary" icon="el-icon-search" class="d2-ml-15"
              @click="handleSearchYearSubmit(selectDate)">搜索
            </el-button>
          </p>
          <p class="welfare_total" v-if="checked.mode == 'myDh'">
            统计日期：<el-date-picker v-model="selectMonthDate" type="month" placeholder="选择月份" @change="handleMonthSubmit"
              format="yyyy/MM" value-format="yyyy/MM" :picker-options="pickerOptions" :editable='false'>
            </el-date-picker>
            <el-button type="primary" icon="el-icon-search" class="d2-ml-15"
              @click="handleSearchYearSubmit1(selectMonthDate)">搜索
            </el-button>
          </p>
          <p class="welfare_total" v-if="checked.mode == 'myDh'">
            本月消耗积分：{{ amount }}分
          </p>
          <p v-else-if="checked.mode == 'cash'" class="welfare_total">
            代金券余额：<span class="d2-mr-15">{{ Money }}元</span> 使用金额：{{
              UseMoney
            }}元
          </p>
          <p v-else class="welfare_total">
            起止日期：<span class="d2-mr-15">{{ startDate }}~ {{endDate}}</span>
          </p>
          <!-- {{checked}} -->
          <template v-if="ListData.length != 0">
            <el-col :span="24" v-for="(item, index) in ListData" :key="index" class="list_item_box" :title="item.Title">
              <div class="img-row">
                <img :src="
                    item.Amount >= 0
                      ? require('@/assets/img/shouru.png')
                      : require('@/assets/img/zhichu.png')
                  " />
              </div>
              <div class="list_item_info">
                <p class="list_item_title">
                  {{ item.BillTypeName || item.LYXHSM || "-"
                  }}<span class="list_item_time" v-if="item.Remark">(来源：{{ item.Remark || "-" }})</span>
                </p>
                <div class="list_item_content">
                  {{ item.BillType == 4 ? "" : item.Reason }}
                </div>
                <div class="list_item_time">
                  {{ item.CreateTime || item.CJSJ }}
                </div>
              </div>
              <div class="align-center">
                <span class="list_item_time">{{
                  (item.Amount >= 0 ? "+" + item.Amount : item.Amount) ||
                  (item.SL >= 0 ? "+" + item.SL : item.SL)
                }}</span>
              </div>
            </el-col>
            <el-col :span="24" class="align-center mt-20">
              <span class="no_more">没有更多了~</span>
            </el-col>
          </template>
          <template v-else>
            <el-empty :image-size="200"></el-empty>
          </template>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-else>
      <el-empty class="auto"></el-empty>
    </template>

    <el-dialog title="积分捐赠" :visible.sync="dialogVisible" width="450px" :before-close="handleClose"
      :append-to-body="true">
      <div class="d2-text-center">
        <el-input-number v-model="donationValue" @change="handleChange" :min="0" :max="Balance" :precision="2" :step="1"
          size="small">
        </el-input-number>
      </div>
      <div class="d2-text-center d2-mt-20">
        <span style="font-size: 12px; color: #666666">您最多可捐<span style="color: #45aeff">{{ Balance }}</span>积分</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" plain size="small">取 消</el-button>
        <el-button type="primary" @click="sureDonationSubmit" size="small">确定捐赠</el-button>
      </span>
    </el-dialog>

    <!-- 积分汇总 -->
    <el-dialog title="积分汇总" :visible.sync="summaryVisible" width="50%" :before-close="handleSummaryClose"
      :append-to-body="true">
      <el-descriptions border :column="2">
          <el-descriptions-item label="剩余积分" labelStyle="width:20%">{{summaryOption.remainAmount}}</el-descriptions-item>
          <el-descriptions-item label="总计发放积分" labelStyle="width:20%">{{summaryOption.allAmount}}</el-descriptions-item>
          <el-descriptions-item label="京东实际消费积分">{{ summaryOption.jdAmount }}</el-descriptions-item>
          <el-descriptions-item label="京东消费积分">{{ summaryOption.jdUseAmount }}</el-descriptions-item>
          <el-descriptions-item label="京东退款积分">{{summaryOption.jdBackAmount}}</el-descriptions-item>
          <el-descriptions-item label="东方福利实际消费积分">{{summaryOption.bfdAmount}}</el-descriptions-item>
          <el-descriptions-item label="东方福利消费积分">{{ summaryOption.bfdUseAmount }}</el-descriptions-item>
          <el-descriptions-item label="东方福利退款积分">{{ summaryOption.bfdBackAmount }}</el-descriptions-item>
          <el-descriptions-item label="捐赠积分">{{summaryOption.donateAmount}}</el-descriptions-item>
          <el-descriptions-item label="清零积分">{{ summaryOption.clearAmount }}</el-descriptions-item>
          <el-descriptions-item label="其他">{{ summaryOption.otherAmount }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="summaryVisible = false" plain size="small">取 消</el-button>
        <el-button type="primary" @click="summaryVisible = false" size="small">确定</el-button>
      </span>
    </el-dialog>

    <!-- 积分转赠他人 -->
    <el-dialog title="积分转赠他人" :visible.sync="transferVisible" width="450px" :before-close="handleTransferVisibleClose"
      :append-to-body="true" :loading="loadsing">
      <div class="d2-text-center">
        <el-input-number v-model="donationValue" @change="handleChange" :min="0" :max="Balance" :precision="2" :step="1"
          size="small">
        </el-input-number>
        <el-form class="d2-mt-15" ref="form" :model="form" label-width="120px" size="small" style="width:90%;margin:0 auto;">
          <el-form-item prop="adAccount" label="受赠人AD账号" :rules="[{ required: true, message: '不能为空', trigger: 'blur'}]">
            <el-input v-model="form.adAccount" @blur="adAccountCheck" placeholder="请输入AD账号"></el-input>
          </el-form-item>
          <el-form-item prop="email" label="受赠人邮箱"
            :rules="[
              { required: true, message: '邮箱不能为空' },
              {
                type: 'email',
                message: '请输入正确的邮箱地址',
                trigger: 'blur',
              },
            ]">
            <el-input v-model="form.email"  placeholder="请输入邮箱地址"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="d2-text-center d2-mt-20">
        <span style="font-size: 12px; color: #666666">
              注：每个年度仅能转赠一次积分，请谨慎使用。
              您最多可转<span style="color: #45aeff">{{ Balance }}</span>积分</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="transferVisible = false" plain size="small">取 消</el-button>
        <el-button type="primary" @click="sureTransferSubmit" size="small">确定转赠</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
  import dayjs from "dayjs";
  import _ from "lodash";
  import {
    mapState,
    mapGetters,
    mapActions
  } from "vuex";
  import * as indexService from "@/api/sys/index";
  export default {
    name: "listWelfare",
    data() {
      return {
        loadsing:false,
        Year: dayjs().format("YYYY"),
        Month: dayjs().format("YYYY/MM"),
        Balance: 0,
        BalanceMoney: 0,
        UseMoney: 0,
        Money: 0,
        amount: 0,
        startDate: dayjs(new Date()).startOf("year").format("YYYY-MM-DD"),
        startDate1: dayjs(new Date()).startOf("month").format("YYYY-MM-DD"),
        endDate: dayjs(new Date()).format("YYYY-MM-DD"),
        selectDate: dayjs().format("YYYY"),
        selectMonthDate: dayjs().format("YYYY/MM"),
        pickerOptions: {
          //日期选择
          disabledDate(date) {
            return date.getTime() > Date.now();
          },
        },
        donationValue: 0,
        dialogVisible: false,
        // 
        summaryVisible:false,
        summaryOption:{},
        transferVisible:false,
        form: {},
        cangiftVisible:false,
        userName:'',
        loading:false
      };
    },
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      checked: {
        type: Object,
        required: false,
        default: {},
      },
      ListData: {
        type: Array,
        required: false,
        default: () => [],
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
      total: {
        type: Number,
        required: false,
        default: 0,
      },
    },
    watch: {
      'checked.mode': function (val) {
        if (val == "cash") {
          this.GetMoneyBalanceForUser();
        } else if (val == "score") {
          this.GetBalance();
        } else {
          this.GetMonthConsume();
        }
      },
    },
    created() {
      if (this.checked.mode == "cash") {
        this.GetMoneyBalanceForUser();
      } else if (this.checked.mode == "score") {
        this.GetBalance();
        this.CheckCanGift();
      } else {
        this.GetMonthConsume();
      }
    },
    mounted() {},
    computed: {
      ...mapGetters("d2admin", {
        themeActiveSetting: "theme/activeSetting",
      }),
      ...mapState("d2admin/userInfo", ["userinfo"]),
      ampm() {
        var time = dayjs().format("ah");
        if (time[0] == "a") {
          return "上午好";
        }
        if (time[0] == "p") {
          return "下午好";
        }
        return "你好";
      },
    },
    methods: {
      goExchangePlat() {
        this.$router.push({
          path: "webView",
          query: {
            code: "plat",
            shortTitle: "积分兑换平台",
            detailed: false,
            dataId: "",
            fiter: "",
          },
        });
      },
      GetBalance() {
        let parmas = {
          MemberCode: "",
        };
        indexService.GetBalance(parmas).then((data) => {
          this.Balance = data.Balance;
        });
      },
      CheckCanGift(){
        indexService.CheckCanGift().then((data) => {
          this.cangiftVisible = data.data;
        });
      },
      GetMoneyBalanceForUser() {
        let parmas = {
          year: this.Year,
        };
        indexService.GetMoneyBalanceForUser(parmas).then((data) => {
          var {
            allMoney,
            balance,
            money,
            useMoney
          } = data;
          this.BalanceMoney = balance;
          this.UseMoney = useMoney;
          this.Money = money;
        });
      },
      GetMonthConsume() {
        let parmas = {};
        this.checked.tab.forEach((v) => {
          if (v.param) {
            parmas = {
              ...parmas,
              billType: v.param.billType,
            };
          }
        });
        parmas = {
          ...parmas,
          date: this.startDate1,
        };
        indexService.GetMonthConsume(parmas).then((data) => {
          this.amount = data.data.amount;
        });
      },
      handleYearSubmit(val) {
        let now = dayjs(new Date()).format("YYYY");
        let values = dayjs(val).format("YYYY");
        this.startDate = dayjs(val).startOf("year").format("YYYY-MM-DD");
        if (now == values) {
          this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
        } else {
          this.endDate = dayjs(val).endOf("year").format("YYYY-MM-DD");
        }
        this.Year = values;
      },
      handleMonthSubmit(val) {
        if (val) {
          let now = dayjs(new Date()).format("YYYY/MM");
          let values = dayjs(val).format("YYYY/MM");
          this.startDate1 = dayjs(val).startOf("month").format("YYYY-MM-DD");
          if (now == values) {
            this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
          } else {
            this.endDate = dayjs(val).endOf("month").format("YYYY-MM-DD");
          }
          this.Month = values;
        } else {
          this.$message.error("统计日期不能为空，默认本月");
          this.startDate1 = dayjs(new Date())
            .startOf("month")
            .format("YYYY-MM-DD");
          this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
          this.Month = dayjs(new Date()).format("YYYY/MM");
          this.selectMonthDate = dayjs().format("YYYY/MM");
          console.log(this.selectMonthDate);
        }
      },
      handleSearchYearSubmit: _.debounce(
        function (search) {
          this.pageIndex = 0;
          this.$emit("searchyear", this.pageIndex, this.startDate, this.endDate);
        },
        1000, {
          leading: true,
          trailing: false,
        }
      ),
      handleSearchYearSubmit1: _.debounce(
        function (search) {
          this.pageIndex = 0;
          this.$emit("searchyear", this.pageIndex, this.startDate1, this.endDate);
          this.GetMonthConsume();
        },
        1000, {
          leading: true,
          trailing: false,
        }
      ),
      donationHandle() {
        this.dialogVisible = true;
      },
      summaryHandle(){
        this.summaryVisible=true;
        let parmas = {
          memberCode:this.userinfo.uInfo.AdAccount,
          year: this.Year,
        };
        indexService.IntegralStatisticsByUser(parmas).then((data) => {
          this.summaryOption = data.data;
        });
      },
      transferHandle(){
        this.transferVisible=true
      },
      adAccountCheck(event){
        console.log(event)
        let parmas = {
          adAccount:this.form.adAccount,
        };
        console.log(parmas)
        indexService.GetUserInfoForAdAccount(parmas).then((data) => {
         this.userName=data.data?data.data.Name:''
        });
      },
      handleTransferVisibleClose(){
        this.transferVisible=false;
        this.form={};
        this.donationValue = 0.0;
      },
      sureTransferSubmit(){
        this.$refs["form"].validate(valid => {
          if (valid) {
            let f = this.form;
            if(!this.userName){
              this.$message.error('请输入正确的AD账号');
              return
            }
            if(Number(this.donationValue)<= 0){
              this.$message.error('转赠积分必须大于0');
              return
            }

            if(Number(this.donationValue) > this.Balance){
              this.$message.error('转赠积分必须小于' + this.Balance);
              return
            }

            let content=`<p>您正在对${this.userName}<br>AD账号：${f.adAccount}<br>邮箱地址：${f.email}<br>准备转赠<b style="color:#409EFF">${this.donationValue}</b>积分<br>请确认以上信息是否有误</p>`
            this.$alert(content, "积分捐赠", {
              dangerouslyUseHTMLString: true,
              callback: (action) => {
                if (action == "confirm") {
                  let param = {
                    adAccount:f.adAccount,
                    email:f.email,
                    amount: this.donationValue,
                  };
                  this.loadsing=true
                  indexService
                    .GiftAmountToAdAccount(param)
                    .then((data) => {
                      this.$alert("积分转赠他人", `你已成功转赠${this.donationValue}积分`);
                      this.handleTransferVisibleClose();
                      this.pageIndex = 0;
                      this.$emit("searchyear", this.pageIndex, this.startDate1, this.endDate);
                      this.loadsing=false
                      this.cangiftVisible=false;
                    })
                    .catch((e) => {
                      this.$message.error(data.message);
                      this.loadsing=false
                    });
                }
              },
            });
          } else {
            return false;
          }
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.donationValue = 0.0;
      },
      handleChange(value) {
        console.log(value);
      },
      sureDonationSubmit() {
        if(Number(this.donationValue)<= 0){
          this.$message.error('转赠积分必须大于0');
          return
        }

        if(Number(this.donationValue) > this.Balance){
          this.$message.error('转赠积分必须小于' + this.Balance);
          return
        }
        let content='<p>是否确认捐赠<b style="color:#409EFF">'+this.donationValue+'</b>积分？</p>'
        this.$alert(content, "积分捐赠", {
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            if (action == "confirm") {
              let param = {
                Amount: this.donationValue,
              };
              this.loadsing=true
              indexService
                .SavePresent(param)
                .then((data) => {
                  this.$alert("积分转赠他人", `你已成功转赠${this.donationValue}积分`);
                  this.handleClose();
                  this.pageIndex = 0;
                  this.$emit("searchyear", this.pageIndex, this.startDate1, this.endDate);
                  this.loadsing=false
                })
                .catch((e) => {
                  this.$message.error(data.message);
                  this.loadsing=false
                });
            }
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";

  .box-shadow {
    margin: auto auto;
    padding: 10px;
    box-shadow: 0px 0px 15px #bfd3e8;
    border-radius: 10px;
  }

  .welfare_header {
    font-size: 20px;
    margin: 5px 10px;
  }

  .welfare_total {
    font-size: 14px;
    color: #999;
    margin: 5px 10px;

    span {
      color: #99caf3;
    }
  }
</style>